import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface MessMenuItemApi {
  menuItemId: number;
  itemNameEn: string;
  itemNameTe: string;
}

export interface MessMenuScenarioApi {
  scenarioId: number;
  scenarioName: string;
  messMenuItems: MessMenuItemApi[];
}
@Injectable({
  providedIn: 'root'
})
export class MessService {
  
  // MAIN COMPONENT CSS WIDTH CHANGE //

  private widthSubject = new BehaviorSubject<any>('100%');
  width$ = this.widthSubject.asObservable();

  updateWidth(width: any) {
    this.widthSubject.next(width);
  }

  // HEADER AND SIDE BAR CHANGE CSS //

  private collapsed = new BehaviorSubject<boolean>(true);
  collapsed$ = this.collapsed.asObservable();

  //CHANGE SIDE BAR MENU LIST //

  // private viewSubject = new BehaviorSubject<string>('grievance');
  private viewSubject = new BehaviorSubject<string>('');
  view$ = this.viewSubject.asObservable();

  setView(viewName: string) {
    localStorage.setItem('routeNames', viewName);
    this.viewSubject.next(viewName);
  }

  /** Params for mess-do-detail-view when opened via landing setView (list → detail). */
  private doDetailViewParamsSubject = new BehaviorSubject<Record<string, string | number | boolean> | null>(null);
  doDetailViewParams$ = this.doDetailViewParamsSubject.asObservable();

  setDoDetailViewParams(params: Record<string, string | number | boolean> | null): void {
    this.doDetailViewParamsSubject.next(params);
  }

  getDoDetailViewParams(): Record<string, string | number | boolean> | null {
    return this.doDetailViewParamsSubject.value;
  }

  clearDoDetailViewParams(): void {
    this.doDetailViewParamsSubject.next(null);
  }

  /** Params for admin-division-report when opened via landing setView. */
  private adminDivisionReportParamsSubject = new BehaviorSubject<Record<string, string | number | boolean> | null>(null);
  adminDivisionReportParams$ = this.adminDivisionReportParamsSubject.asObservable();

  setAdminDivisionReportParams(params: Record<string, string | number | boolean> | null): void {
    this.adminDivisionReportParamsSubject.next(params);
  }

  getAdminDivisionReportParams(): Record<string, string | number | boolean> | null {
    return this.adminDivisionReportParamsSubject.value;
  }

  clearAdminDivisionReportParams(): void {
    this.adminDivisionReportParamsSubject.next(null);
  }

  /** Params for admin-mess-inventory when opened via landing setView. */
  private adminMessInventoryParamsSubject = new BehaviorSubject<Record<string, string | number | boolean> | null>(null);
  adminMessInventoryParams$ = this.adminMessInventoryParamsSubject.asObservable();

  setAdminMessInventoryParams(params: Record<string, string | number | boolean> | null): void {
    this.adminMessInventoryParamsSubject.next(params);
  }

  getAdminMessInventoryParams(): Record<string, string | number | boolean> | null {
    return this.adminMessInventoryParamsSubject.value;
  }

  clearAdminMessInventoryParams(): void {
    this.adminMessInventoryParamsSubject.next(null);
  }

  /** Params for mess-excel when opened via landing setView (closed list → excel). */
  private messExcelParamsSubject = new BehaviorSubject<Record<string, string | number | boolean> | null>(null);
  messExcelParams$ = this.messExcelParamsSubject.asObservable();

  setMessExcelParams(params: Record<string, string | number | boolean> | null): void {
    this.messExcelParamsSubject.next(params);
  }

  getMessExcelParams(): Record<string, string | number | boolean> | null {
    return this.messExcelParamsSubject.value;
  }

  clearMessExcelParams(): void {
    this.messExcelParamsSubject.next(null);
  }

  toggleCollapse() {
    this.collapsed.next(!this.collapsed.value);
  }

  openSidebar() {
    this.collapsed.next(false);
  }

  // hide the selector //
  private reportsSelectedSource = new BehaviorSubject<boolean>(false);
  reportsSelected$ = this.reportsSelectedSource.asObservable();

  setReportsSelected(value: boolean) {
    this.reportsSelectedSource.next(value);
  }


  // admin dashboard //
  private token = '';
  // barath anna //
  // private token = 'eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiI5bzVINkEwelZ6aE5BRVo0WmlCQ2olMkIlMkYxMFd3S0tvTFJRS1lEMnMlMkZPNTJVRW5TVjdrdVBuRWloRCUyQnMlMkZzeGk3VTNmdG5UTTN2WGZNelNCWnc1b29PSDdFZnc3cmNNenElMkI3aFF1VTFwdUN4OCUzRCIsInRva2VuUmVmcmVzaEtleSI6ImNPaExTd0IlMkZmV2t2MVNBOFdNMVQlMkY3bkh4UnZEZlVhVnpVUURkbmlGOXZkaWJMREsxbmpES0I1ZDNzclZ5Z015IiwiY2FtcHVzSWQiOjQ1NywicGF5cm9sbElkIjoiSFlEMTEwMDEwMDUyIiwidXNlck5hbWUiOiJQSUxMQUxBTUFSUkkgQkhBUkFUS1VNQVIiLCJleHAiOjE3ODUzMDk4NjQsInVzZXJJZCI6IkhZRDExMDAxMDA1MiIsImlhdCI6MTc4NTIyMzQ2NCwidW5pcXVlSWQiOjQzNTMyMywicGxhdGZvcm0iOiJTQ0FJVFMiLCJqdGkiOiI2NmI5MjViZC1mNGNjLTQ1ZDUtYTlhNC04ZDU3YmJkOWY0OGIifQ.AxYh4S3P2LKx6CTMKrF4-PdeJqKO4G09CScMf0og6yCCTOG52nW41xdLHe4XuhP9soHNzGGtRtFyS2lDet_aGw';
  //  razaaq anna //
  // private token = 'eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiIzOHpjRGdlZmE0OGhuSk1LVU82bWwzNE1VQkVuUzZhb21tMmVuckxGNiUyQmRqUUxWYzNlalhuQXdYJTJCSVlmUWlOSXlMNU9rcCUyRmdLNHBFc1MwYTZ2NnlLN3U1QWpseWtqVW5qNkFUM1VFbjZzUSUzRCIsInRva2VuUmVmcmVzaEtleSI6IklZOUpJZUdpJTJCdHJuUndOS3YxaUQlMkZQNnEyZEFGRSUyRkI4cE1FYmJaRklIJTJCVklodXFPUHNnTlZUYXJJSzB0ampPdyIsImNhbXB1c0lkIjoxMDIsInBheXJvbGxJZCI6IkhZRDExMDAwNTc3OSIsInVzZXJOYW1lIjoiUkFKQUsgUEFTSEEgUyIsImV4cCI6MTc4NTA0NzcyNywidXNlcklkIjoiSFlEMTEwMDA1Nzc5IiwiaWF0IjoxNzg0OTYxMzI3LCJ1bmlxdWVJZCI6NDM1Mjk4LCJwbGF0Zm9ybSI6IlNDQUlUUyIsImp0aSI6ImJmYzU1ZDAyLWQ1OTktNDQ0NS1iZWI3LWNjNmI3MzUzNTJiMSJ9.bkHTT112i0e-Og_LEIVKmFbgPkTdg2J3w7NwoUSSk4BozOiOJ-jPbcQheWe3ulqFZKw-WPD7C6FRRu4RHIAGrA';
  //  satya sir //
  // private token = 'eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiJtR3FWRDV2TERrNk9jMG5KTHFaUzg0TGp3QThNdiUyQjg5cHBiVzRTUkJMM0RDJTJGbEtJbDgwYllGUlRuNmQ2MkFlM1VyNDdpZ2JTd3N3VnhRMmJPY0VKcHI1akk0czRCTDRLJTJCSWZSWGNyQjRqYyUzRCIsInRva2VuUmVmcmVzaEtleSI6IjE4R2dnWmgyVkdWWmpqSGoyT1lEamhybGppWGNRbDY0aHQlMkJXSzElMkZQZWZyd3REWE0zQ1JRQnlqeVlwdzJwOXJHIiwiY2FtcHVzSWQiOjE3OSwicGF5cm9sbElkIjoiSFlEMTAzMTM1IiwidXNlck5hbWUiOiJDSCBTQVRZQU5BUkFZQU5BIiwiZXhwIjoxNzg1MDQyMjEzLCJ1c2VySWQiOiJIWUQxMDMxMzUiLCJpYXQiOjE3ODQ5NTU4MTMsInVuaXF1ZUlkIjoyODQ4NiwicGxhdGZvcm0iOiJTQ0FJVFMiLCJqdGkiOiIyYzIwYjdlOS0xNjExLTQ2N2MtOTc1Yy0wMDc1Y2E1NmQ0MGQifQ.ptK0KYwIHI13u_osRH7YehOEz4QmzkM8kQJJvxWavvv1DD2dNgvrYmgluL2PjFt2bFetW0_JTYprynLnLYMUPw'

  constructor(private http: HttpClient) { }

  // ROLE MANAGEMENT //
  getRolemanagement(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/common/userRoles?payrollId=' + payrollId, { headers });
  }

    getstudentCount(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/studentCount?payrollId=' + payrollId, { headers })
  }

  postUploadMess(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });

    return this.http.post(
      environment.employeeURL + '/jwtV2/api/mess/daysheet/uploadMessInventoryData',
      payload,
      { headers, responseType: 'text' }
    );
  }

  getAllocatedcampus() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empAllocatedCmpBuilding', { headers })
  }

  getvalidate(buildingId: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.employeeURL + '/jwtV2/api/mess/validate/DaysheetDate?buildingId=' + buildingId + '&inventoryDate=' + date, { headers })
  }

  getItemList(building: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.employeeURL + '/jwtV2/api/mess/daysheetDetails?buildingId=' + building + '&inventoryDate=' + date, { headers })
  }

  postMessInventory(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/daysheet/saveInventoryDetails', payload, { headers })
  }

  // new requirement in mess

  userBuildings() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/userBuildings', { headers })
  }

  regularItems(buildingId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/regularItems?buildingId=' + buildingId, { headers })
  }

  itemSearch(buildingId: any, search: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/itemSearch?searchKey=' + search + '&buildingId=' + buildingId, { headers })
  }

  // InventoryDetails(buildingId: any, date: any) {
  //   const headers = new HttpHeaders({
  //     'Authorization': `${this.token}`
  //   });
  //   return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/daysheet/getInventoryDetails?buildingId=' + buildingId + '&daysheetDate=' + date, { headers })
  // }
  InventoryDetails(buildingId: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const encodedDate = encodeURIComponent(String(date ?? ''));
    return this.http.get(
      `${environment.masterDomain}/employee/api/jwtV2/mess/daysheet/getInventoryDetails?buildingId=${buildingId}&daysheetDate=${encodedDate}`,
      { headers },
    );
  }

  supplyBuildingDetails(buildingId: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/supplyBuildingDetails?messBuildingId=' + buildingId + '&daysheetDate=' + date, { headers })
  }

  messReport(buildingId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/daysheet/details?messBuildingId=' + buildingId, { headers })
  }

  getdouReport() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/dou/daysheet/pendingDetails', { headers })
  }

  getCloseDetails() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/dou/daysheet/closeDetails', { headers })
  }


  // End new requirement in mess

  // Mess Request //

  userKitchens() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/userKitchens', { headers })
  }
  sceniorTypes() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/scenarioTypes', { headers })
  }
  submitFoodRequest(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/submitFoodRequest', payload, { headers })
  }

  foodRequestHistory(supplyId: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/foodRequestHistory?supplyId=' + supplyId + '&requestDate=' + date, { headers })
  }
  //End Mess Request //

  // Holiday //
  holidayDetails() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/holidayDetails', { headers })
  }

  saveHolidayDetails(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/daysheet/saveHolidayDetails', payload, { headers })
  }

  // End Holiday //
  // meal order summary //

  mealOrderSummary(date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.masterDomain + '/employee/api/jwtV2/mess/kitchen/foodRequests?requestDate=' + date, { headers })
  }

  employeeProfileImage(payrollId: any){
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(
      environment.masterDomain + '/employee/api/jwtV2/userId/profileImage?payrollId=' + payrollId,
      { headers, responseType: 'blob' },
    );
  }

  // Dou //
  monthlyDouReport(month: number | string, year: number | string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const m = String(month).padStart(2, '0');
    return this.http.get(
      environment.masterDomain + '/employee/api/jwtV2/mess/dou/daysheet/monthlyReport?month=' + m + '&year=' + year,
      { headers },
    );
  }

  // Menu Card //
  getMenuCard(): Observable<MessMenuScenarioApi[]> {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get<MessMenuScenarioApi[]>(
      environment.masterDomain + '/employee/api/jwtV2/mess/kitchen/messMenuItems',
      { headers },
    );
  }

  // Admin Dashboard //

  adminDashboardReport(month: number | string, year: number | string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const m = String(month).padStart(2, '0');
    return this.http.get(
      environment.masterDomain + '/employee/api/jwtV2/mess/admin/daysheet/monthlyReport?month=' + m + '&year=' + year,
      { headers },
    );
  }

  adminReports(month: number | string, year: number | string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const m = String(month).padStart(2, '0');
    return this.http.get(
      environment.masterDomain + '/employee/api/jwtV2/mess/admin/daysheet/monthlySummary?month=' + m + '&year=' + year,
      { headers },
    );
  }

  //save items details //

  saveItemsDetails(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/daysheet/saveItemDetails', payload, { headers })
  }

  addMissingMenuItem(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/admin/menuItem/addMissingMenuItem', payload, { headers })
  }

  adminDivisionReport(month: number | string, year: number | string, divisionName: string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const m = String(month).padStart(2, '0');
    const encodedDivision = encodeURIComponent(String(divisionName ?? '').trim());
    return this.http.get(
      `${environment.masterDomain}/employee/api/jwtV2/mess/admin/daysheet/monthlyReport?month=${m}&year=${year}&divisionName=${encodedDivision}`,
      { headers },
    );
  }

  // ADMIN MESS INVENTORY //
  adminMessInventory(buildingId: any, date: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const encodedDate = encodeURIComponent(String(date ?? ''));
    return this.http.get(
      `${environment.masterDomain}/employee/api/jwtV2/mess/daysheet/admin/getInventoryDetails?buildingId=${buildingId}&daysheetDate=${encodedDate}`,
      { headers },
    );
  }

  adminUpdateClosedInventory(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/admin/daysheet/updateClosedInventoryDetails', payload, { headers })
  }

  adminSaveInventoryDetails(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.masterDomain + '/employee/api/jwtV2/mess/admin/daysheet/saveItemDetails', payload, { headers })
  }

  // End ADMIN MESS INVENTORY //

}



